import { useState, useEffect } from "react";
import { $host } from "../../../../http";
import WebinarCard from "../../components/cards/WebinarCard";

const Streams = () => {
    const [webinars, setWebinars] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        fetchWebinars();
    }, [page]);

    const fetchWebinars = async () => {
        setLoading(true);
        try {
            const response = await $host.get("/api/teachers/webinars-records", {
                params: { page, limit: 21 },
                withCredentials: true,
            });

            setWebinars(response.data.records || []);
            setTotalPages(response.data.total_pages || 1);
        } catch (err) {
            setError(err.response?.data?.error || "Ошибка загрузки вебинаров");
        }
        setLoading(false);
    };

    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= totalPages) {
            setPage(newPage);
        }
    };

    return (
        <div className="p-4">
            <h2 className="text-lg font-semibold mb-4">Мои вебинары</h2>
            {error && <p className="text-red-500">{error}</p>}
            {loading && <p className="text-gray-500">Загрузка...</p>}

            {webinars.length === 0 && !loading ? (
                <p className="text-gray-600">Нет записей вебинаров</p>
            ) : (
                <div className="grid grid-cols-3 gap-4">
                    {webinars.map((webinar) => (
                        <WebinarCard
                            key={webinar.id}
                            id={webinar.id}
                            title={webinar.name}
                            createdAt={webinar.created_at}
                            videoPreview={webinar.video_preview}
                            videoUrl={webinar.link_recording}
                        />
                    ))}
                </div>
            )}

            {/* Пагинация */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center mt-4 space-x-4">
                    <button
                        onClick={() => handlePageChange(page - 1)}
                        className="px-4 py-2 bg-gray-300 rounded-md"
                        disabled={page === 1}
                    >
                        Назад
                    </button>
                    <span className="text-gray-700">Страница {page} из {totalPages}</span>
                    <button
                        onClick={() => handlePageChange(page + 1)}
                        className="px-4 py-2 bg-gray-300 rounded-md"
                        disabled={page === totalPages}
                    >
                        Вперед
                    </button>
                </div>
            )}
        </div>
    );
};

export default Streams;
